import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'std-input',
  templateUrl: './input.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class InputComponent implements ControlValueAccessor {
  @Input() type = 'text';
  @Input() customInputClass = '';
  @Input() customContainerlass = '';
  @Input() placeholder = 'Placeholder';
  @Input() label!: string;
  @Input() customLabel: string = '';
  @Input() labelPosition: 'left' | 'top' | 'right' | 'bottom' = 'left';
  @Input() value: any = null;

  public onChange: any = () => {};
  public onTouched: any = () => {};

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  writeValue(value: any): void {
    this.value = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInputChange(event: Event) {
    this.onChange(event);
    this.value = event;
    this.changeDetectorRef.detectChanges();
  }

  checkEnter(event: any) {}
}
